import { BrowserRouter } from 'react-router-dom'

import './styles/app.scss'
import LoginPage from './pages/LoginPage/LoginPage'
import { useRecoilState } from 'recoil'
import { userState } from './store/user'
import { tokenState } from './store/token'
import PageLayout from './components/shared/PageLayout'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

function App() {
  const [user, setUser] = useRecoilState(userState)
  const [token, setToken] = useRecoilState(tokenState)

  return (
    <BrowserRouter>
      {user && user?.id && token.accessToken && token.refreshToken ? (
        <DndProvider backend={HTML5Backend}>
          <PageLayout></PageLayout>
        </DndProvider>
      ) : (
        <LoginPage></LoginPage>
      )}
    </BrowserRouter>
  )
}

export default App
